import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IconLight } from 'components/icons/icons-theme/icon-light';
import { IconDark } from 'components/icons/icons-theme/icon-dark';

import './theme-switcher-toggle.scss';
import { withThemeMode } from '../../hocs/with-theme-mode';

export const ThemeSwitcherToggleUI = ({
  className,
  isUserLoggedIn,
  switchMode,
  themeMode,
}) => {
  const [isAnimated, setIsAnimated] = useState(false);

  const handleClick = useCallback(() => {
    switchMode();
    setIsAnimated(true);
  }, []);

  useEffect(() => {
    if (!themeMode) {
      setIsAnimated(true);
    }
  }, []);

  return (
    <div className="d-flex align-items-center justify-content-center font-weight-semi-bold toggle-wrapper w-100 bg-gray-0 bg-switch-theme-dark-secondary mt-1">
      <span className="mr-2 text-switch-white">Dark</span>
      <div
        className={classNames(
          'theme-switcher-toggle-container bg-gray-4 d-flex position-relative',
          { 'mr-2': isUserLoggedIn },
          className
        )}
        onClick={handleClick}
        onKeyPress={handleClick}
        tabIndex="0"
        role="button"
      >
        <div className={classNames('slider d-flex justify-content-center align-items-center position-absolute', {
          active: !themeMode,
          isAnimated,
        })}
        >
          <IconDark className="icon-dark" />
          <IconLight className="icon-light" />
        </div>
      </div>
      <span className="ml-2 text-switch-white">Light</span>
    </div>
  );
};

ThemeSwitcherToggleUI.propTypes = {
  className: PropTypes.string,
  isUserLoggedIn: PropTypes.string,
  switchMode: PropTypes.string.isRequired,
  themeMode: PropTypes.bool.isRequired,
};

ThemeSwitcherToggleUI.defaultProps = {
  className: null,
  isUserLoggedIn: false,
};

export const ThemeSwitcherToggle = withThemeMode(ThemeSwitcherToggleUI);
